import { ChangeDetectorRef, Component } from '@angular/core';
import { ChatbotService } from '../../services/chatbot.service';
import { ChatbotConversationBase } from './chatbot-conversation.mixin';

@Component({
  selector: 'app-chatbot-fab',
  templateUrl: './chatbot-fab.component.html',
  styleUrls: ['./chatbot-fab.component.css', './chatbot-layout.css']
})
export class ChatbotFabComponent extends ChatbotConversationBase {

  open = false;
  fontSize = 14;
  showGuidebook = false;

  guideCommands = [
    'Ask questions about company data',
    'Ask for meeting schedules [example: "schedule a {meeting-type} meeting on {date} at {time}"]',
    'Get Company Secretary information',
    'Use quick-reply buttons when DigiBot asks a question',
    'Use suggestions to start a new task after completing one'
  ];

  constructor(
    private readonly chatbotService: ChatbotService,
    private readonly cdr: ChangeDetectorRef
  ) {
    super();
  }

  protected getChatbotService(): ChatbotService {
    return this.chatbotService;
  }

  toggleChat(): void {
    this.open = !this.open;
    this.cdr.detectChanges();
  }

  increaseFontSize(): void {
    if (this.fontSize < 20) {
      this.fontSize += 2;
    }
  }

  decreaseFontSize(): void {
    if (this.fontSize > 10) {
      this.fontSize -= 2;
    }
  }

  toggleGuidebook(): void {
    this.showGuidebook = !this.showGuidebook;
  }
}
